import _ from 'lodash'

import { ApiKey } from '@/core/models/apiKey.model'
import { AuthUser } from '@/core/classes/Auth'
import { Patient } from '@/core/models/patient.model'
import { Staff } from '@/core/models/staff.model'
import { Role } from '@/core/types/shared'
import { Admin } from '@/core/models/admin.model'
import { ErrorResponse } from '@/core/types/response'
import { AccountType } from '@/core/models/account.model'
import { ConsultationOrder } from '@/core/models/consultation-order.model'
import { ExpertiseOrder } from '@/core/models/expertise-order.model'
import { Order } from '@/core/models/order.model'
import { MeetingLinkOrder } from '@/core/models/meeting-link-order.model'

export function isApiFetchError(error: unknown): error is { data: ErrorResponse; status: number } {
  return !!error && _.get(error, 'data.success') === false
}

export function isAdmin(user?: AuthUser | null): user is Admin {
  return !_.isNil(user) && !!user._id && user.accountType === AccountType.Admin && user.roles.includes(Role.Admin)
}

export function isApiKey(account: AuthUser | ApiKey | null): account is ApiKey {
  return !_.isNil(account) && !!account._id && account.accountType === AccountType.ApiKey
}

export function isPatient(user?: AuthUser | null): user is Patient {
  return !_.isNil(user) && !!user._id && user.accountType === AccountType.Patient && user.roles.includes(Role.Patient) && _.get(user, 'secu') !== undefined
}

export function isStaff(user?: AuthUser | ApiKey | null): user is Staff {
  return (
    !_.isNil(user) &&
    !!user._id &&
    user.accountType === AccountType.Staff &&
    user.roles.includes(Role.Staff) &&
    _.includes(['MEDECIN', 'PDS'], _.get(user, 'status'))
  )
}

export function isDoctor(user?: AuthUser | null): user is Staff {
  return isStaff(user) && user.status === 'MEDECIN'
}

export function isPDS(user?: AuthUser | null): user is Staff {
  return isStaff(user) && user.status === 'PDS'
}

export function isSuperAdmin(user?: AuthUser | null): user is Admin {
  return !_.isNil(user) && !!user._id && user.accountType === AccountType.Admin && user.roles.includes(Role.SuperAdmin)
}

export function isConsultationOrder(order: Order): order is ConsultationOrder {
  return order.type === 'ConsultationOrder' && !!_.get(order, 'consultation')
}

export function isExpertiseOrder(order: Order): order is ExpertiseOrder {
  return order.type === 'ExpertiseOrder' && !!_.get(order, 'expertise')
}

export function isMeetingLinkOrder(order: Order): order is MeetingLinkOrder {
  return order.type === 'MeetingLinkOrder'
}
